// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    production: false,
    apiKey: 'AIzaSyB6QRfWapq8IZtACrQzEc9N2kNDoWlHY84',    // firebase 웹 api 키
    authDomain: 'flwaypawnshop.firebaseapp.com',
    databaseURL: 'https://flwaypawnshop.firebaseio.com',
    projectId: 'flwaypawnshop',
    storageBucket: 'flwaypawnshop.appspot.com',
    messagingSenderId: '1087950906166'  // firebase 프로젝트 번호
  }
};



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/environments/environment.ts